import * as React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useDate } from '@/modules/drivers/stores/dateStore'
import ViolationsSingle from '../tabs/violations_new/views/ViolationsSingle'
import { TableProvider } from '../context/TableContext'

export const DriverViolationsPageNew = () => {
  const { companyId, driverId, from, to } = useParams<{
    companyId: string
    driverId: string
    from?: string
    to?: string
  }>()
  const navigate = useNavigate()
  const { getDateRangeForView } = useDate()

  // If landing on the route without a date range, redirect to the legacy
  // `/violation/from/:from/to/:to` path seeded with the stored default range.
  // (TODO: align on one route shape — either `/violation` or `/violation-new`.)
  React.useEffect(() => {
    if (driverId && companyId && (!from || !to)) {
      const { from: defaultFrom, to: defaultTo } = getDateRangeForView()
      navigate(
        `/et/company/${companyId}/driverModule/driver/${driverId}/violation/from/${defaultFrom}/to/${defaultTo}`,
        { replace: true },
      )
    }
  }, [driverId, companyId, from, to, navigate, getDateRangeForView])

  return (
    <TableProvider>
      <div className="tw-flex tw-h-full tw-w-full tw-flex-col">
        <ViolationsSingle driverId={driverId} />
      </div>
    </TableProvider>
  )
}
